export const restaurantOrdersEn = {
  title: {
    deliveryTakeaway: 'Delivery & takeaway',
    deliveryTakeawayConfiguration: 'Delivery & takeaway configuration',
    orderHistoryDocument: 'Order history · Delivery & takeaway',
    orderHubEyebrow: 'Order hub',
    operationalManagement: 'Operational management',
  },
  workspace: {
    selectBranchToManage: 'Select a branch to manage {{title}}.',
    newOrder: 'New order',
    searchOrderPlaceholder: 'Search order…',
    orderTypeAriaLabel: 'Order type',
    channelDelivery: 'DELIVERY',
    channelTakeaway: 'TAKEAWAY',
    processedAriaLabel: 'Processed',
    processedTitle: 'Processed orders',
    processed: 'Processed',
    refreshOrdersLabel: 'Refresh orders',
    refreshOrdersTitle: 'Refresh orders',
    attentionLabel: 'To manage',
    unsupportedStatesAlert:
      '{{count}} orders have API statuses incompatible with the new workflow.',
    unsupportedStatesHint:
      'They appear on the calendar but cannot be auto-assigned to board columns. Verify the statuses returned by the backend.',
  },
  board: {
    elapsedNow: 'Now',
    elapsedMinutesAgo: '{{minutes}} min ago',
    elapsedHoursAgo: '{{hours}} h ago',
    elapsedDaysAgo: '{{days}} d ago',
    productsCount: '{{count}} items',
    paymentMethodTitle: 'Payment method',
    orderCardAriaLabel:
      'Order {{id}} · {{name}}. Enter to open, space to drag.',
    columnSubtitles: {
      inArrivo: 'New orders to review',
      accettato: 'Confirmed orders',
      inLavorazione: 'Orders in preparation',
      pronto: 'Ready for pickup or delivery',
    },
    archiveReadyTitle: 'Archive ready orders',
    archiveReadyAriaLabel: 'Archive ready orders',
    dropHere: 'Drop here',
    noOrders: 'No orders',
    orderUpdatedRetry: 'Order updated. Retry with the current status.',
  },
  detail: {
    orderTitle: 'Order #{{id}} · {{channel}}',
    orderDetail: 'Order detail',
    refreshOrderLabel: 'Refresh order',
    refreshOrderTitle: 'Refresh order',
    orderActivityLabel: 'Order activity',
    orderActivityTitle: 'Order activity',
    loadError: 'Unable to load the order.',
    scheduledDelivery: 'Scheduled delivery',
    scheduledPickup: 'Scheduled pickup',
    deliveryAddress: 'Delivery address',
    pickupPoint: 'Pickup point',
    emptyAddress: '—',
    outcome: 'Outcome:',
    orderDishes: 'Order items',
    editDishes: 'Edit items',
    allergens: 'Allergens:',
    perDish: '{{price}} / item',
    deliveryFeeLine: 'Delivery {{fee}}',
    orderUpdatedToast: 'Order updated.',
    operationFailed: 'Operation failed. Reload the details and try again.',
    moveOrder: 'Move order',
    orderNumber: 'Order #{{id}}',
    chooseStatus: 'Choose status',
    reopenToStatus: 'Return to status',
    chooseOperationalStatus: 'Choose an operational status',
    orderOutcome: 'Order outcome',
    chooseReason: 'Choose a reason',
    confirmMove: 'Confirm the move',
    notifyCustomer: 'Notify customer',
    doNotNotify: 'Do not notify',
    unpaidTitle: 'Order not paid yet',
    unpaidBody:
      'This order is not paid yet. Are you sure you want to move it to in preparation?',
    unpaidHint:
      'Payment will remain pending. This action does not charge the customer.',
    noActivity: 'No activity recorded.',
    depositNotAuthorizedApi:
      'Deposit is not authorized yet. Wait for customer payment authorization.',
  },
  create: {
    title: 'New order',
    description:
      'Choose the service, add products, and complete customer details.',
    loadServicesError: 'Unable to load services.',
    loadingServices: 'Loading services…',
    publishServiceHint:
      'Publish a takeaway or delivery service in Configuration.',
    whichService: 'Which service do you want to use?',
    loadingMenuSlots: 'Loading menu and time slots…',
    loadMenuSlotsError: 'Unable to load menu and time slots.',
    noModeAvailable: 'No mode available for this service.',
    operationFailed: 'Operation failed. Try again.',
    addAtLeastOneProduct: 'Add at least one product.',
    productUnavailable: 'A product is no longer available.',
    checkProducts: 'Check the products.',
    enterCustomerName: 'Enter the customer first and last name.',
    enterValidPhone: 'Enter a valid phone number with country code.',
    fixOrClearEmail: 'Fix the email or leave the field empty.',
    chooseDayAndSlot: 'Choose an available day and time.',
    chooseActiveDriver: 'Choose an active driver or leave “Assign later”.',
    enterFullDeliveryAddress:
      'Enter the full delivery address including street number.',
    reloadService: 'Reload the service.',
    quoteExpired:
      'The quote has expired. Review the details and refresh the summary.',
    stepsAriaLabel: 'New order steps',
    steps: {
      service: 'Service',
      products: 'Products',
      customer: 'Customer',
      confirm: 'Confirm',
    },
    footerProductsTotal: '{{count}} items · {{total}}',
    footerTotalOrder: 'Order total',
    footerDeliveryInSummary: 'Delivery fee in summary',
    wait: 'Please wait…',
    stepActions: {
      chooseProducts: 'Choose products',
      customerDetails: 'Customer details',
      reviewOrder: 'Review order',
      createOrder: 'Create order',
    },
    channelSectionTitle: 'How will the customer receive the order?',
    channelSectionHint: 'Takeaway: they pick it up. Delivery: we deliver it.',
    channelTakeaway: 'Takeaway',
    channelDelivery: 'Delivery',
    changeChannelConfirm: 'Switch mode and clear the products already added?',
    whatToOrder: 'What would they like to order?',
    menuCategoriesAriaLabel: 'Menu categories',
    allMenu: 'Full menu',
    otherProducts: 'Other products',
    searchProduct: 'Search for a product',
    searchProductPlaceholder: 'Product name…',
    fromMenu: 'From menu',
    addProductAria: 'Add {{name}}',
    compose: 'Configure',
    add: 'Add',
    cartAriaLabel: 'Items in order',
    yourOrder: 'Your order',
    chooseProductToStart: 'Choose a product from the menu to get started.',
    noExtraOptions: 'No extra options',
    decreaseQtyAria: 'Decrease quantity',
    decreaseQtyForAria: 'Decrease quantity of {{name}}',
    quantityForAria: 'Quantity of {{name}}',
    increaseQtyForAria: 'Increase quantity of {{name}}',
    anotherConfiguration: 'Another configuration',
    removeConfigurationAria: 'Remove configuration {{index}}',
    subtotal: 'Subtotal',
    customerAndFulfillment: 'Customer and {{fulfillment}}',
    fulfillmentDelivery: 'delivery',
    fulfillmentPickup: 'pickup',
    customerRequiredHint: 'First name, last name, and phone are required.',
    emailOptional: 'Email (optional)',
    emailPlaceholder: 'customer@example.com',
    fullAddress: 'Full address',
    fullAddressPlaceholder: 'Street, number, ZIP and city',
    driver: 'Driver',
    assignLater: 'Assign later',
    driversLoadError: 'Unable to load drivers. You can assign one later.',
    deliveryTime: 'Delivery time',
    pickupTime: 'Pickup time',
    bookUntil: 'You can book until {{date}}.',
    notesOptional: 'Notes (optional)',
    notesPlaceholder: 'Intercom, kitchen instructions…',
    reviewAndCreate: 'Review and create the order',
    driverLine: 'Driver:',
    toAssign: 'To assign',
    afterCreateHint:
      'After creation you can manage the order and request a deposit.',
    productConfigHint:
      'Choose ingredients for this configuration. For different ingredients, add another configuration.',
    requiredSuffix: ' · required',
    quantity: 'Quantity',
    reduceQuantityAria: 'Decrease quantity',
    addToOrder: 'Add to order',
    saveChanges: 'Save changes',
    selection: {
      quantityRange: 'Choose a quantity between 1 and 99.',
      productUnavailableForService: 'Product not available for this service.',
      optionUnavailable: 'One of the selected options is not available.',
    },
    cartErrors: {
      invalidLine: 'Invalid order line.',
      maxSameConfiguration:
        'You can add at most 99 units of the same configuration.',
      maxConfigurations: 'Maximum 100 configurations per order.',
      configurationsRange: 'Add between 1 and 100 configurations.',
      invalidAmountOrPercentage: 'Invalid amount or percentage.',
      checkOrderProducts: 'Check the order products.',
      minimumOrder: 'Minimum order: € {{amount}}.',
      invalidDeliveryFee: 'Invalid delivery fee. Reload the service.',
    },
  },
  history: {
    selectBranch: 'Select a branch to view orders.',
    subtitleDefault: 'Delivery & takeaway',
    searchTitle: 'Search history',
    searchHint:
      'Choose a period or search for an order. Results update automatically.',
    searchPlaceholder: 'Order number, customer, product, or contact…',
    moreFilters: 'More filters',
    invalidDateRange: 'The date range is not valid.',
    exporting: 'Exporting…',
    exportCsv: 'Export CSV',
    exportFailed: 'Export failed. No partial file was downloaded. Try again.',
    driversListUnavailable: 'Driver list unavailable.',
    searchUnavailable:
      'Search unavailable. Filters did not return a verified result.',
    searching: 'Searching orders and summaries…',
    exactMatch: 'Exact match',
    containsMatch: 'Contains text search',
    exactMatchHint: 'Longer names are not included.',
    ordersFound: 'Orders found',
    ordersFoundHint: 'Based on the selected period and filters',
    completedValue: 'Completed orders value',
    completedValueHint:
      '{{count}} completed orders · total amount, even if not yet paid',
    stillUnpaid: 'Still unpaid',
    noUnpaidInResults: 'No unpaid orders in the results',
    unpaidInResults: '{{count}} unpaid orders in the results',
    ordersByDriver: 'Orders by driver',
    ordersByDriverHint: 'Current assignee, including archived orders.',
    driverSummary: '{{completed}} completed · {{unpaid}} to collect',
    orderList: 'Order list',
    orderListHint: 'Use “Details” to open an order.',
    resultsPage: '{{total}} results · Page {{page}} of {{pages}}',
    loadingPage: 'Loading page…',
    noOrdersForFilters: 'No orders for these filters',
    table: {
      order: 'Order',
      dateTime: 'Date & time',
      channel: 'Channel',
      orderStatus: 'Order status',
      payment: 'Payment',
      driver: 'Driver',
      total: 'Total',
      notAssigned: 'Not assigned',
      openOrderAria: 'Open order {{id}}',
    },
    modalProcessed: 'Processed orders',
    modalHistory: 'Order history',
    filters: {
      paid: 'Paid',
      unpaid: 'Unpaid',
      allMethods: 'All methods',
      allDrivers: 'All',
      unassigned: 'Unassigned',
      deliveryAndTakeaway: 'Delivery & takeaway',
      allStatuses: 'All',
      afterProcessed: 'Status after processed',
      sortBy: 'Sort by',
      sortRecent: 'Most recent',
      sortOldest: 'Oldest',
      sortTotalHigh: 'Highest total',
      unassignedOnly: 'Unassigned',
      driverFilter: 'Driver: {{name}}',
    },
    export: {
      incompleteResults: 'Incomplete results. Try again.',
      filename: 'order-history.csv',
      headers: {
        order: 'Order',
        customer: 'Customer',
        email: 'Email',
        phone: 'Phone',
        schedule: 'Delivery / pickup',
        channel: 'Channel',
        products: 'Products',
        driver: 'Driver',
        totalEur: 'Total EUR',
        orderStatus: 'Order status',
        paymentStatus: 'Payment status',
        paymentMethod: 'Payment method',
      },
      productLine: '{{quantity}} × {{name}}',
    },
    pagination: {
      perPage: 'Per page',
      ordersCount: '{{count}} orders',
      previous: 'Previous',
      next: 'Next',
    },
    topCustomersHint:
      'Top 10 by completed order value, across all filtered results.',
    noCompletedInResults: 'No completed orders in the results.',
  },
  drivers: {
    manageHint: 'Manage collaborators assignable to deliveries.',
    addDriver: 'Add driver',
    loadError: 'Unable to load drivers.',
    empty: 'No drivers configured',
    columns: {
      driver: 'Driver',
      phone: 'Phone',
      status: 'Status',
      actions: 'Actions',
    },
    active: 'Active',
    inactive: 'Inactive',
    ordersAndMap: 'Orders & map',
    deleteTitle: 'Delete driver',
    deleteConfirm:
      'Delete {{name}}? Access will be revoked and open orders will become unassigned. History will be kept.',
    deleteAction: 'Delete driver',
    deletedToast: 'Driver deleted.',
    deleteError: 'Unable to delete the driver.',
    editTitle: 'Edit driver',
    newTitle: 'New driver',
    username: 'Login name',
    passwordNew: 'Password · at least 4 characters',
    passwordKeep: 'New password (leave blank to keep current)',
    passwordMinError: 'Enter at least 4 characters.',
    accessHint:
      'The driver signs in from the scooter button on the public menu. Share credentials directly with them. The password will not be shown again.',
    activeToggleAria: 'Active driver',
    activeToggle: 'Active driver',
    savedToast: 'Driver saved.',
    saveError: 'Unable to save the driver.',
    createdByDriver: 'Created by driver:',
    assignedLabel: 'Assigned driver',
    notAssigned: 'Not assigned',
    deactivatedSuffix: ' · deactivated',
    deletedSuffix: ' · deleted',
    driverLine: 'Driver:',
    assignSuccess: 'Driver assigned',
    unassignSuccess: 'Assignment removed',
    assignError: 'Unable to assign the driver.',
    discountCard: 'Discount card',
    giftCard: 'Gift Card:',
    giftCardCaptured: 'Charged',
    giftCardReleased: 'Released',
    giftCardReserved: 'Reserved',
    amountDue: 'To collect:',
  },
  config: {
    title: 'Delivery & takeaway configuration',
    sectionAriaLabel: 'Takeaway and delivery services',
    introTitle: 'Manage how you receive orders',
    introBody:
      'Use Edit to set menu, days, hours, and payments for each service. Share the link or QR code so customers can order.',
    searchPlaceholder: 'Search for a service…',
    newService: 'New service',
    templateLoadError: 'Unable to load initial data.',
    servicesLoadError: 'Unable to load services.',
    emptySearch: 'No services match your search',
    empty: 'No services configured',
    columns: {
      service: 'Service',
      orderType: 'Order type',
      visibility: 'Visibility',
      manageShare: 'Manage & share',
    },
    preparationMinutes: 'Prep {{minutes}} min',
    advanceDays: 'Orders up to {{days}} days in advance',
    deliveryPausedSuffix: ' · paused',
    visibleToCustomers: 'Visible to customers',
    draftNotVisible: 'Draft · not visible',
    openPage: 'Open page',
    servicesPerPage: 'Services per page',
    range: '{{start}}–{{end}} of {{total}}',
    previous: 'Previous',
    next: 'Next',
    linkCopied: 'Link copied.',
    copyManually: 'Copy the link shown manually.',
    removedToast: 'Service removed. Existing orders are kept.',
    removeError: 'Unable to remove the service.',
    shareModalTitle: 'Customer link · {{name}}',
    published: 'Published',
    draftPublishHint: 'Draft · publish the service to receive orders',
    publicLinkLabel: 'Public delivery / takeaway link',
    shareHint:
      'The customer will choose among enabled channels and available slots for this service.',
    removeTitle: 'Remove service',
    removeConfirm:
      'Remove “{{name}}”? The service will no longer accept new orders. Existing orders and history will be kept.',
    removeAction: 'Remove service',
    editor: {
      editTitle: 'Edit service',
      newTitle: 'New service',
      stepService: '1 · Service',
      stepProducts: '2 · Products',
      stepSchedulePayments: '3 · Schedule & payments',
      savePublish: 'Save & publish',
      saveDraft: 'Save draft',
      serviceName: 'Service name',
      serviceNameHint:
        'This name is the title of the public page customers open from the link or QR code to order delivery or takeaway.',
      chooseMenu: 'Choose menu',
      menusLoadError: 'Unable to load menus.',
      enableTakeaway: 'Enable takeaway',
      enableDelivery: 'Enable delivery',
      restaurantPhoto: 'Restaurant photo (optional)',
      restaurantPhotoHint:
        'Click to choose and upload a photo from your device.',
      removeRestaurantPhoto: 'Remove restaurant photo',
      photoLoading: 'Uploading photo…',
      photoUploadedToast: 'Photo uploaded. Save the service to confirm.',
      photoUploadError: 'Unable to upload the restaurant photo.',
      photoNoUrl: 'Upload did not return the image URL. Try again.',
      productsIntro:
        'Choose available products and prices per channel. Ingredients and variants come from the shared menu. To confirm a changed price, press Save next to the field.',
      searchProductsPlaceholder: 'Search for a product or section…',
      productsLoadError: 'Unable to load products.',
      productsLoading: 'Loading products…',
      noProducts: 'No products found',
      chooseMenuFirst: 'Choose a menu first',
      sectionControlsHint:
        '{{count}} products · controls apply to the whole section, even while searching.',
      partial: ' · Partial',
      activeCount: '{{enabled}}/{{total}} active',
      sectionToggleAria: '{{channel}}: entire section {{name}}',
      product: 'Product',
      takeaway: 'Takeaway',
      delivery: 'Delivery',
      options: 'Ingredients & options',
      syncedWithMenu: ' · Synced with Menu',
      priceAria: '{{channel}} price {{name}}',
      savePriceAria: 'Save {{channel}} price {{name}}',
      invalidPrice: 'Enter a valid price greater than or equal to zero.',
      updateFailed: 'Update failed',
      productsUpdatedPartial:
        '{{completed}} of {{total}} products updated. Not updated: {{failures}}',
      priceUpdatedToast: 'Price updated.',
      productsUpdatedToast: '{{count}} products updated.',
      menuLoadFailed: 'Unable to load the menu. No changes were applied.',
      recipeSyncHint:
        'Synced product toggles update the recipe immediately, including in Menu and other services using it. Prices saved here also update Menu and other services. Cancel does not undo these changes. For non-synced products, save the service to confirm. Edit ingredients in Menu.',
      prepMinutes: 'Average prep (min)',
      slotMinutes: 'Delivery/pickup slot length (minutes)',
      slotHint:
        'With 15 minutes, the customer can choose 7:00–7:15 PM, then 7:15–7:30 PM. Prep time is set separately.',
      advanceDaysLabel: 'Maximum order lead time (days)',
      advanceDaysHint:
        'With 7 days, the customer can order for a date within the next 7 days, during configured opening hours.',
      minimumOrder: 'Minimum order (€)',
      freeDeliveryFrom: 'Free delivery from (€)',
      deliveryRadius: 'Delivery radius (km)',
      weeklyCalendar: 'Weekly calendar · order receiving hours',
      from: 'From',
      slotStartAria: 'Slot start {{index}}',
      slotEndAria: 'Slot end {{index}}',
      removeSlotAria: 'Remove slot',
      addSlot: 'Add slot',
      paymentMethods: 'Accepted payment methods',
      cardOnly: 'Card only',
      cashAndCard: 'Cash & card',
      stripeChecking: 'Checking Stripe…',
      stripeRequired:
        'To enable card payments, complete Stripe setup and branch onboarding.',
      cardStripeError:
        'To enable card payments, complete Stripe setup and branch onboarding.',
      publication: 'Publication',
      pauseDelivery: 'Temporarily pause delivery',
      pauseDeliveryHint:
        'The delivery section of this service can be disabled temporarily. Re-enable it by unchecking and saving the service. Takeaway stays available if enabled.',
      publishService: 'Publish service',
      savedPublishedToast: 'Service saved as published.',
      savedDraftToast: 'Draft saved.',
      saveError: 'Unable to save the service.',
      pendingPrices:
        'Save changed prices with the button next to each field before continuing.',
      distanceBandsUnsupported:
        'The linked API must be updated to save distance bands.',
      distanceBandsNotReturned:
        'The server did not return the saved bands. Configuration stays open: reload the service before trying again.',
      productDetailsTitle: 'Product details · {{name}}',
      productDetails: 'Product details',
      closeDetails: 'Close details',
      ingredients: 'Ingredients:',
      allergens: 'Allergens:',
      notSpecified: 'Not specified',
      noOptionsForChannel: 'No options for this channel',
      group: 'Group',
      ingredient: 'Ingredient',
      supplement: 'Supplement',
      minMax: 'Min. {{min}}{{max}}',
      maxSuffix: ' · Max. {{max}}',
      weekdays: {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
      },
    },
    validation: {
      serviceName: 'Enter a service name (maximum 120 characters).',
      chooseMenu: 'Choose the service menu.',
      enableChannel: 'Enable at least delivery or takeaway.',
      integerRange:
        '{{label}}: enter a whole number between {{min}} and {{max}}.',
      preparation: 'Preparation',
      slotDuration: 'Slot duration',
      bookableDays: 'Bookable days',
      amounts: 'Enter positive amounts with at most two decimal places.',
      deliveryRadius:
        'Delivery radius must be greater than 0 and at most 100 km.',
      timezone: 'Enter a valid time zone.',
      location: 'Complete address and coordinates in branch configuration.',
      geocoding: 'Delivery area verification service is not configured.',
      openingHours: 'Enter between 1 and 28 opening slots.',
      openingHoursOrder:
        'Check opening slots: end time must be after start time.',
      enableProduct: 'Enable at least one product for an active channel.',
      productPrices: 'Check product prices.',
    },
  },
  modals: {
    archive: {
      title: 'Archive ready orders',
      intro:
        'Selected orders will be archived: delivery as Delivered, takeaway as Picked up. Payment method stays unchanged.',
      markAllPaid: 'Mark all selected as paid',
      deliverySection: 'Delivery · Delivered',
      takeawaySection: 'Takeaway · Picked up',
      paid: 'Paid',
      noReadyOrders: 'No ready orders.',
      archiving: 'Archiving…',
      archiveCount: 'Archive {{count}} orders',
      archiveError: 'Archiving failed. Reload orders and try again.',
    },
    processed: {
      title: 'Processed orders · {{date}}',
      searchPlaceholder: 'Search customer, phone, or order number…',
      orderOutcome: 'Order outcome',
      allReasons: 'All reasons',
      empty: 'No archived orders',
      columns: {
        order: 'Order',
        channel: 'Channel',
        schedule: 'Delivery / pickup time',
        total: 'Total',
        driver: 'Driver',
        outcome: 'Outcome',
        payment: 'Payment',
      },
      perPage: 'Per page',
      ordersCount: '{{count}} orders',
      previous: 'Previous',
      next: 'Next',
    },
    payment: {
      cardTitle: 'Card payment',
      loadingStripe: 'Loading Stripe form…',
      loadError:
        'Unable to load payment. The order is saved and awaiting payment.',
      retryPayment: 'Retry payment',
      payAmount: 'Pay {{amount}}',
      confirmedOnPayment:
        'The order will be confirmed when payment is received.',
      paymentFailed: 'Payment failed. Try again.',
      paymentIncomplete: 'Payment not completed. Try again.',
      verifyFailed: 'Unable to verify payment. Retry on the same order.',
    },
    itemsEditor: {
      title: 'Edit items',
      titleWithOrder: 'Edit items · Order #{{id}}',
      loadError:
        'Order editing requires the new backend APIs. No data was changed.',
      loadingMenu: 'Loading menu…',
      notEditable: 'This order cannot be edited in its current status.',
      saveError:
        'Unable to save. Reload the order if another operator changed it.',
      menuChannel: 'Menu · {{channel}}',
      searchPlaceholder: 'Search for a dish or section…',
      orderItems: 'Order items · {{count}}',
      removeDishAria: 'Remove dish',
      quantity: 'Quantity',
      decreaseQtyAria: 'Decrease quantity',
      optionIssue: 'Check availability and min/max selected ingredients.',
      addAtLeastOne:
        'Add at least one item. To cancel the order use the dedicated action.',
      verifiedTotal: 'Verified new total',
      recalcHint:
        'The server recalculates prices and supplements before saving. Changes stay local until “Save changes”.',
      verifyTotal: 'Verify new total',
      saveChanges: 'Save changes',
      unsavedConfirm: 'Leave without saving item changes?',
      dishFallback: 'Item {{index}}',
    },
  },
  address: {
    suggestionsUnavailable:
      'Suggestions unavailable. Try again shortly to select the street.',
    searching: 'Searching addresses…',
    suggestionsCount:
      '{{count}} suggested addresses. Use arrows to choose and Enter to confirm.',
    notFound: 'No address found. Check the street and add the city.',
    verifyStreet: 'Verifying street and street number…',
    verifyFailed:
      'We could not verify the street. Select a suggestion again to retry.',
    selectFromSuggestions:
      'Select the street from suggestions before continuing.',
    deliveryAddressSrOnly: 'Delivery address',
    placeholder: 'Street, number, city and ZIP',
    suggestedAddressesAria: 'Suggested addresses',
    hint: 'Choose the street from suggestions and complete the street number.',
    streetNumber: 'Street number *',
    streetNumberPlaceholder: 'e.g. 10, 10/A',
    deliveryAddressPreview: 'Delivery address:',
    yourAddress: 'Your address',
    streetOnlyCity:
      'Select a street from suggestions, not just a city or area.',
    fullAddressItaly: 'Select a full address with street and city in Italy.',
    streetNumberRequired: 'Enter the street number to continue.',
    streetNumberInvalid:
      'Enter a valid street number, e.g. 10, 10/A or 10 bis.',
  },
  pricing: {
    ariaLabel: 'Delivery cost',
    title: 'How do you calculate delivery cost?',
    intro:
      'Choose one cost for everyone or a total price for each distance band.',
    fixedCost: 'Fixed cost',
    distanceBands: 'Distance bands',
    fixedFeeLabel: 'Cost per delivery (€)',
    fixedFeeHint:
      'The same amount for all addresses within the delivery radius.',
    bandsUnsupported:
      'Linked APIs do not yet support saving bands. You can prepare them here; saving will be available after the service is updated.',
    bandsFlow:
      '1. Address within {{radius}} km radius → 2. Road route → 3. Band cost',
    bandsFlowHint:
      'Price is the total delivery cost. Kilometers are one-way road distance from the venue to the customer. The last band covers any further distance for already accepted addresses.',
    allDistances: 'All distances',
    overKm: 'Over {{km}} km',
    lastBandHint: 'Last band · no additional road limit',
    bandUpTo: 'Band {{index}} · up to (km)',
    bandFromZero: 'From 0 km, limit included.',
    bandAfterPrevious: 'After {{km}} km, limit included.',
    bandCost: 'Band {{index}} · total cost (€)',
    removeBandAria: 'Remove band {{index}}',
    addBand: 'Add band',
    bandChecksAria: 'Band checks',
    simulateDistance: 'Simulate road distance (km)',
    completeBandsForCost: 'Complete bands to see the cost.',
    enterValidDistance: 'Enter a valid road distance.',
    costAtDistance: 'Delivery cost at {{km}} km: {{price}}',
    previewHint: 'Band price preview, before any free-delivery threshold.',
    bandErrors: {
      count: 'Enter between 1 and 30 distance bands.',
      lastBand: 'Band {{index}}: the last band covers all further distances.',
      distance:
        'Band {{index}}: enter a distance greater than the previous, up to 1,000 km.',
      fee: 'Band {{index}}: enter a cost from 0 to 999,999.99 € with at most two decimal places.',
    },
  },
  payment: {
    sectionAria: 'Order payment',
    paid: 'Paid',
    markPaid: 'Mark as paid',
    paymentStatus: 'Payment status',
    toPay: 'To pay',
    saving: 'Saving payment…',
    specialStatusHint:
      'Pending, refunded, or cancelled order payments need dedicated review.',
    updateError: 'Unable to update payment. Reload the order and try again.',
    branchUnavailable: 'Branch unavailable.',
    deposit: {
      ariaLabel: 'Request deposit',
      title: 'Request a deposit',
      intro:
        'Choose the percentage of the {{total}} total. The customer will receive a link to pay.',
      received: 'Received:',
      remaining: 'Remaining to pay:',
      defaultUnavailable: 'Payment links unavailable: configure Stripe.',
      verifyBeforeNew:
        'This order’s payment needs review before requesting a new deposit.',
      creating: 'Creating…',
      linkCreated: 'Link created',
      createLinkFor: 'Create link for {{amount}}',
      requested: 'Deposit requested: {{amount}}',
      customerLink: 'Customer link',
      messageSent: 'Message sending / sent',
      sending: 'Sending…',
      sendWhatsApp: 'Send to customer on WhatsApp',
      copied: 'Copied',
      copyLink: 'Copy link',
      copyFromField: 'Copy the link from the field above.',
      whatsAppHint:
        'Uses the “Payment link” message configured in Message Center. Creating or sending the link does not mark the order as paid.',
      requestMismatch:
        'The returned request does not match the chosen deposit. Reload the order.',
      requestUnavailable:
        'Request unavailable. The API service must support order deposits.',
      sendNotConfirmed: 'Send not confirmed.',
      sendError:
        'Unable to send the message. Check WhatsApp configuration for the Payment link message.',
      invalidPaymentRequest: 'Invalid payment request.',
      invalidPaymentLink: 'Invalid payment link.',
    },
  },
  labels: {
    inArrivo: 'Incoming',
    accettato: 'Accepted',
    archiviato: 'Processed',
    accept: 'Accept order',
    archive: 'Mark as processed',
    reopen: 'Reopen order',
    eliminato: 'Deleted',
    nonConsegnato: 'Not delivered',
    delivery: 'Delivery',
    takeaway: 'Takeaway',
    ricevuto: 'Received',
    presaInCarico: 'Taken in charge',
    confermato: 'Taken in charge',
    inAttesaDiPagamento: 'Awaiting payment',
    inLavorazione: 'In preparation',
    pronto: 'Ready',
    ritirato: 'Picked up',
    inConsegna: 'Out for delivery',
    consegnato: 'Delivered',
    rifiutato: 'Rejected',
    annullato: 'Cancelled',
    nonRitirato: 'Not picked up',
    consegnaFallita: 'Delivery failed',
    daPagare: 'To pay',
    inAttesa: 'Pending',
    pagato: 'Paid',
    parzialmentePagato: 'Deposit received',
    unspecified: 'To be defined',
    fallito: 'Failed',
    rimborsato: 'Refunded',
    cash: 'Cash',
    card: 'Card',
    takeCharge: 'Take charge',
    reject: 'Reject order',
    prepare: 'Start preparation',
    ready: 'Mark ready',
    assign: 'Assign driver',
    dispatch: 'Leave for delivery',
    collect: 'Confirm pickup',
    deliver: 'Confirm delivery',
    fail: 'Report problem',
    cancel: 'Cancel order',
    cashPaid: 'Record cash payment',
    refund: 'Refund to card',
    cashRefund: 'Record cash refund',
    notCollected: 'Not picked up',
    active: 'To manage',
    completed: 'Completed',
    issues: 'Cancelled / issues',
    scheduleAsap: 'As soon as possible',
  },
} as const;
